import { useEffect, useState } from 'react'

/** Mensi rozdil dela adresni radek prohlizece, klavesnice je vzdy vyssi. */
const KEYBOARD_MIN_PX = 120

/**
 * Vyska softwarove klavesnice nad spodnim okrajem; 0 = zavrena. Nastavuje i
 * CSS promennou --keyboard-inset: Safari na iPhonu pri klavesnici nezmensi
 * rozvrzeni a pevne prvky u spodni hrany by zmizely pod ni.
 */
export function useKeyboardInset(): number {
  const [inset, setInset] = useState(0)

  useEffect(() => {
    const viewport = window.visualViewport
    if (!viewport) return
    const root = document.documentElement
    const update = () => {
      const covered = Math.round(window.innerHeight - viewport.height - viewport.offsetTop)
      const next = covered > KEYBOARD_MIN_PX ? covered : 0
      setInset(next)
      root.style.setProperty('--keyboard-inset', `${next}px`)
    }
    update()
    viewport.addEventListener('resize', update)
    viewport.addEventListener('scroll', update)
    return () => {
      viewport.removeEventListener('resize', update)
      viewport.removeEventListener('scroll', update)
      root.style.removeProperty('--keyboard-inset')
    }
  }, [])

  return inset
}
